module.exports = __webpack_public_path__ + "static/media/let8.f7ad344b.JPG";